import { useQuery } from "@tanstack/react-query";
import { baseApiUrlWithoutVersion } from "~constants/baseApiUrl";
import { request } from "~utils/request";

export const useHealthCheck = () => {
  return useQuery({
    queryKey: ["healthCheck"],
    queryFn: async () => {
      const response = await request<any>(`${baseApiUrlWithoutVersion}/health`);
      return response?.data?.[0]?.success === true;
    },
  });
};
